import cn from "classnames";
import { ClassValue } from "classnames/types";
import { createBemBlockBuilder as buildBEMString } from "@ebsco-ui/utils";

export interface GetWrapperClassnamesArgs {
  consumerWrapperClassName?: string;
  consumerBaseClassName?: string;
  modifiers?: ClassValue[];
  defaultBaseClassName: string;
}
/**
 * @example
 * Wrapper class name as element:
 * getWrapperClassNames("base__wrapper", "base", ["--open"]) => "base__wrapper base__wrapper--open"
 *
 * Wrapper class name as block:
 * getWrapperClassNames(true, undefined, "base", ["--open"]) => "base base--open"
 *
 * Optional modifier:
 * getWrapperClassNames(true, undefined, "base", [isOpen && "--open"]) => "base base--open" or "base"
 */
export const getWrapperClassNames = ({
  consumerWrapperClassName,
  consumerBaseClassName,
  modifiers,
  defaultBaseClassName,
}: GetWrapperClassnamesArgs) => {
  const getBEMBlocksWith = buildBEMString([
    defaultBaseClassName,
    consumerWrapperClassName ?? consumerBaseClassName,
  ]);

  return cn(
    getBEMBlocksWith(),
    modifiers?.map(
      (modifier) => typeof modifier === "string" && getBEMBlocksWith(modifier),
    ),
  );
};
